import api from './api';
import { CrvPhase, CraPhase, PhPhase } from '../types/Phase';

// CRV Phase Service
export const crvPhaseService = {
  getAll: (productId: string) => api.get<CrvPhase[]>(`/products/crv/${productId}/phases`),
  getById: (productId: string, id: string) => api.get<CrvPhase>(`/products/crv/${productId}/phases/${id}`),
  create: (productId: string, data: CrvPhase) => api.post<CrvPhase>(`/products/crv/${productId}/phases`, data),
  update: (productId: string, id: string, data: CrvPhase) => api.put<CrvPhase>(`/products/crv/${productId}/phases/${id}`, data),
  delete: (productId: string, id: string) => api.delete(`/products/crv/${productId}/phases/${id}`),
};

// CRA Phase Service
export const craPhaseService = {
  getAll: (productId: string) => api.get<CraPhase[]>(`/products/cra/${productId}/phases`),
  getById: (productId: string, id: string) => api.get<CraPhase>(`/products/cra/${productId}/phases/${id}`),
  create: (productId: string, data: CraPhase) => api.post<CraPhase>(`/products/cra/${productId}/phases`, data),
  update: (productId: string, id: string, data: CraPhase) => api.put<CraPhase>(`/products/cra/${productId}/phases/${id}`, data),
  delete: (productId: string, id: string) => api.delete(`/products/cra/${productId}/phases/${id}`),
};

// PH Phase Service
export const phPhaseService = {
  getAll: (productId: string) => api.get<PhPhase[]>(`/products/ph/${productId}/phases`),
  getById: (productId: string, id: string) => api.get<PhPhase>(`/products/ph/${productId}/phases/${id}`),
  create: (productId: string, data: PhPhase) => api.post<PhPhase>(`/products/ph/${productId}/phases`, data),
  update: (productId: string, id: string, data: PhPhase) => api.put<PhPhase>(`/products/ph/${productId}/phases/${id}`, data),
  delete: (productId: string, id: string) => api.delete(`/products/ph/${productId}/phases/${id}`),
};
